import { Button } from '@/components/ui/button';
import { useFormsTranslation } from '@/hooks/useTranslation';
import { Loader2 } from 'lucide-react';
import { TabMetadata } from '../types/kycFormTabs.types';

interface FormNavigationButtonsProps {
  activeTab: string;
  tabs: TabMetadata[];
  getCurrentTabIndex: () => number;
  goToPreviousTab: () => void;
  goToNextTab: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
}

/**
 * Component for form navigation buttons (Previous, Submit, Next).
 * Handles tab navigation and form submission actions.
 */
export function FormNavigationButtons({
  activeTab,
  tabs,
  getCurrentTabIndex,
  goToPreviousTab,
  goToNextTab,
  onSubmit,
  isSubmitting,
}: FormNavigationButtonsProps) {
  const tForms = useFormsTranslation();
  const currentIndex = getCurrentTabIndex();
  const isFirstTab = activeTab === 'identification';
  const isLastTab = currentIndex === tabs.length - 1;

  return (
    <div className='flex justify-between items-center mt-8 pt-6 border-t'>
      <Button variant='outline' onClick={goToPreviousTab} disabled={isFirstTab}>
        {tForms.t('kyc.navigation.previous')}
      </Button>

      {/* Submit Button in the middle */}
      <Button
        type='button'
        onClick={onSubmit}
        variant='default'
        className='mx-4'
        disabled={isSubmitting}
      >
        {isSubmitting ? (
          <>
            <Loader2 className='mr-2 h-4 w-4 animate-spin' />
            {tForms.t('kyc.navigation.submitting')}
          </>
        ) : (
          tForms.t('kyc.navigation.submitForm')
        )}
      </Button>

      {!isLastTab && (
        <Button onClick={goToNextTab}>{tForms.t('kyc.navigation.next')}</Button>
      )}
    </div>
  );
}
